import { Menu, menuClasses, MenuItem, Typography } from '@mui/material'
import { FC, PropsWithChildren, ReactNode } from 'react'

export type SidebarMenuItem = {
    key: string
    label: string
    icon?: ReactNode
    color?: string
    onClick: VoidFunction
}

type Props = PropsWithChildren<{
    anchorEl: HTMLElement | null
    menuItems: SidebarMenuItem[]
    onClose?: VoidFunction
    verticalPosition?: 'top' | 'center'
}>

export const SidebarMenu: FC<Props> = ({
    anchorEl,
    menuItems,
    onClose,
    verticalPosition = 'top',
}) => {
    const open = Boolean(anchorEl)

    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            anchorOrigin={{
                vertical: verticalPosition,
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: verticalPosition,
                horizontal: 'left',
            }}
            sx={{
                [`.${menuClasses.paper}`]: {
                    width: 224,
                    borderRadius: '24px',
                    border: '1px solid #DDDDDD',
                    boxShadow: 'none',
                    overflow: 'hidden',
                },
                [`.${menuClasses.list}`]: {
                    p: '12px',
                    maxHeight: 360,
                    overflow: 'auto',
                },
            }}>
            {menuItems.map(({ key, label, icon, color, onClick }) => (
                <MenuItem
                    key={key}
                    onClick={() => {
                        onClick()
                        onClose?.()
                    }}
                    sx={{
                        height: '36px',
                        minHeight: 'unset',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 1,
                        p: '6px 8px',
                        color,
                    }}>
                    <Typography
                        variant="body2"
                        color={color}
                        sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}>
                        {label}
                    </Typography>
                    {icon}
                </MenuItem>
            ))}
        </Menu>
    )
}
